module.exports = __webpack_public_path__ + "static/FAQ-career2-0e8824c44402f6ecae715211937a81a1.jpg";